import { gql } from 'apollo-boost';

export const GET_CANDIDATE_IMAGES = gql`
  query getCandidateImages(
    $organizationRevvUid: String
    $imageType: [ImageTypeEnum!]
    $page: Int
    $limit: Int
    $search: String
    $sort: SortDirectionEnum
    $sort_by: ImageSortByEnum
  ) {
    viewer {
      candidate(revvUid: $organizationRevvUid) {
        images(
          filters: { imageType: $imageType, page: $page, limit: $limit, search: $search, sort: $sort, sortBy: $sort_by }
        ) {
          current_page
          page_count
          total_count
          results {
            id
            type
            imageFileName
            created_at
            dimensions
            fileSize
            fileSizeKb
            originalUrl
            largeUrl
            mediumUrl
            iconUrl
            thumbnailUrl
            squareUrl
            imageProcessing
          }
        }
      }
    }
  }
`;

export const GET_CANDIDATE_IMAGES_WITH_ASSIGNED_COUNT = gql`
  query getCandidateImagesWithAssignedCount(
    $organizationRevvUid: String
    $imageType: [ImageTypeEnum!]
    $page: Int
    $limit: Int
    $search: String
    $sort: SortDirectionEnum
    $sort_by: ImageSortByEnum
  ) {
    viewer {
      candidate(revvUid: $organizationRevvUid) {
        images(
          filters: { imageType: $imageType, page: $page, limit: $limit, search: $search, sort: $sort, sortBy: $sort_by }
        ) {
          current_page
          page_count
          total_count
          results {
            id
            type
            imageFileName
            created_at
            dimensions
            fileSize
            fileSizeKb
            originalUrl
            largeUrl
            mediumUrl
            iconUrl
            thumbnailUrl
            squareUrl
            imageProcessing
            assignedImagesCount
          }
        }
      }
    }
  }
`;

export const REMOVE_CANDIDATE_IMAGE = gql`
  mutation candidateRemoveImageMutation($imageAttributes: RemoveImageInput!) {
    candidateRemoveImage(imageAttributes: $imageAttributes) {
      errors
    }
  }
`;
